/** Compact metric card used across dashboard-style pages. */

import React from "react";
import { useCountUp } from "@/hooks/useCountUp";

interface StatCardProps {
  label: string;
  value: string;
  delta?: string;
  deltaTone?: "positive" | "negative" | "neutral";
}

const TONE_CLASSES: Record<NonNullable<StatCardProps["deltaTone"]>, string> = {
  positive: "text-signal-teal",
  negative: "text-signal-rose",
  neutral: "text-mist-400",
};

export default function StatCard({
  label,
  value,
  delta,
  deltaTone = "neutral",
}: StatCardProps): React.ReactElement {
  const animatedValue = useCountUp(value);

  return (
    <div className="panel p-5 transition-shadow duration-300 hover:shadow-[0_0_30px_-12px_rgba(47,211,166,0.25)]">
      <p className="text-xs font-medium uppercase tracking-wide text-mist-400">{label}</p>
      <p className="mt-2 font-mono text-2xl font-semibold tabular-nums text-mist-100">
        {animatedValue}
      </p>
      {delta && <p className={`mt-1 text-sm ${TONE_CLASSES[deltaTone]}`}>{delta}</p>}
    </div>
  );
}
